import React from "react";
import { DefaultFilterMapToFitlerDTO } from "src/components/Common/UI/DndTable/TableFilterV2/DefaultFilterMapToFitlerDTO";
import FilterProvider from "src/components/Common/UI/DndTable/TableFilterV2/FilterContext";
import FilterView from "src/components/Common/UI/DndTable/TableFilterV2/FilterView/FilterView";
import { unformattedFilterDTO } from "src/components/Common/UI/DndTable/types";
import SpeedsDataView from "./SpeedsDataView";


const Speeds = () => {
  
  const filters: unformattedFilterDTO [] = React.useMemo(
    () => [{
      displayName: "Ταχύτητα Γραμμής",
      columnName: "Description",
      columnDataType: "String",
      gridId: "1",
      operatorID: 14,
      validOperatorIDs: [
        14
      ],
      operatorDataTypeID: 4
    }], [])

  return (
    <FilterProvider
        defaultOrderByKeyFilter={"id"}
        FilterUrl={""}

        //requestFilterData={currentFilterContext.filterData}
        filterData={DefaultFilterMapToFitlerDTO(filters as unknown as unformattedFilterDTO[])}
      >
        <FilterView />
        <SpeedsDataView />

      </FilterProvider>
  )

}
export default Speeds;

